import React from 'react';
import getName from '../../../../helpers/getName';
import styles from './WorkerWithPosition.module.scss';

const WorkerWithPosition = ({ worker }) => {
  return (
    <div className={styles.root}>
      {worker.speciality && (
        <span className={styles.speciality}>{worker.speciality}</span>
      )}
      <span>{worker.name || getName(worker)}</span>
    </div>
  );
};

export default WorkerWithPosition;
